/**
 * Centralized breakpoint constants for responsive design.
 * Aligned with Tailwind CSS breakpoints (sm/md/lg).
 *
 * Three layout tiers:
 *   Mobile  (< 640px)  -- single-viewport flex, no scroll, footer in flow
 *   Tablet  (640-1024)  -- centered card, wider max-width
 *   Desktop (>= 1024)   -- centered card, compact max-width, keyboard-optimized
 */

/** Below this width the form renders in mobile layout (full-viewport flex). */
export const FORM_STYLE_BREAKPOINT = 640; // Tailwind 'sm'

/** Below this width navigation buttons render inside the mobile footer. */
export const BUTTON_POSITION_BREAKPOINT = 640; // Tailwind 'sm'

/** Above this width the card narrows to max-w-md for focused desktop layout. */
export const TABLET_BREAKPOINT = 1024; // Tailwind 'lg'

export const TAILWIND_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;
